import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/tipos-documento`;

export async function getTiposDocumento() {
  const { data } = await axios.get(baseUrl);
  return data;
}

export async function getTipoDocumentoByCodigo(codigo) {
  if (!codigo) {
    return { success: false, data: null };
  }

  const { data } = await axios.get(`${baseUrl}/codigo/${codigo}`);
  return data;
}
